/* eslint-disable comma-dangle */
export default function convertUpperCase(text: string, delimeter: string) {
  const splitText = text.split(delimeter || " ");
  const upperArr = splitText.map(
    (e) => e.slice(0, 1).toUpperCase() + e.slice(1, e.length)
  );
  return upperArr.join(" ");
}
